/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./resUploader.vue?vue&type=template&id=2e98d4fd&"
import script from "./resUploader.vue?vue&type=script&lang=js&"
export * from "./resUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports